const richtextStyles = "_uxsr1vk0ncl";

export { richtextStyles };
import "./shared.richtext.style.linaria.module.css";
//# sourceMappingURL=shared.richtext.style.js.map
